module.exports = __webpack_public_path__ + "static/img/brees-2012-slide-3.c0be08c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2012-slide-3.jpg
// module id = YAJ8
// module chunks = 1